import './designer';

import './buy';
import './catalog';
import './cookie';
import './draggable';
import './intro-designer';
import './modal';
import './popup';
import './smooth-scrolling';

